import { SHAPE_IDENTIFIERS } from "../../order/constants.js";
export const shouldShowStaticSubscriptionPrice = (subscriptionType) => subscriptionType !== SHAPE_IDENTIFIERS.BOOK_CLUB;
